export default "__VITE_ASSET__39cde527__"